import axios from 'axios';

const KEEP_ALIVE_INTERVAL = 1000 * 60 * 4;
let keepAliveTimer = null;

function keepSessionAlive() {
	return axios
		.get(`${process.env.VUE_APP_ROOT}/laravel/public/api/v1/users/current/keep-alive`)
		.catch(() => null);
}

export function startSessionKeepAlive() {
	if (keepAliveTimer) {
		return keepAliveTimer;
	}

	keepSessionAlive();
	keepAliveTimer = window.setInterval(keepSessionAlive, KEEP_ALIVE_INTERVAL);

	return keepAliveTimer;
}

export function stopSessionKeepAlive() {
	if (!keepAliveTimer) {
		return;
	}

	window.clearInterval(keepAliveTimer);
	keepAliveTimer = null;
}
